import '../../httpservices/core/ajax.httpservice.core';

class MskEngageHttpService {

    PageInitData() {
        return $.get('Patient/MskEngage/PageInitData');
    }
    GetCompletedTabData() {
        return $.get('Patient/MskEngage/GetCompletedTabData');
    } 
    GetOnDemandTabData() {
        return $.get('Patient/MskEngage/GetOnDemandTabData');
    }
    GetOnDemandAssessmentId(surveyId) {
        return $.get('Patient/MskEngage/GetOnDemandAssessmentId?surveyId=' + surveyId);
    }
    GetPatientProgress() {
        return $.get('Patient/MskEngage/GetPatientProgress')
    }
    GetToken() {
        return $.get('api/MskEngage/GetToken')
    }
    GetPPPToken() {
        return $.get('/api/MskEngage/GetToken')
    }
    GetPatientOutput(assessmentid) {
        return $.get('Patient/MskEngage/GetPatientOutput?assessmentid=' + assessmentid)
    }

}

export const MskEngageHttpSvc = new MskEngageHttpService();